import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberAlertsListing defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberAlertsListingService } from 'services/memberAlertsListing';
 *
 * // create service instance and send/cancel request
 * const memberAlertsListingService = new MemberAlertsListingService();
 * const result = await memberAlertsListingService.fetchData( '<user-id>' ); // fetch data
 * memberAlertsListingService.cancel(); // cancel an active request
 */
export class MemberAlertsListingService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url, data } = {} ) {
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    state: response.body.component.data.state,
                    navActions: response.body.component.structure.navActions,
                    filters: response.body.component.structure.filters,
                    alertTypes: response.body.component.structure.alerts,
                    alertActions: response.body.component.structure.alertActions,
                    noDataToDisplay: response.body.component.structure.noDataToDisplayText
                }
            };
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // make request, fetch and return sync data
    async fetchSyncData( { url, data } = {} ) {
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: { state: response.body.component.data.state }
            };
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // submit show later alert request
    async submitShowLaterRequest( { url, data } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data' )
            };
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
}
